/* eslint-disable */
/**
 * Paraglide's Intl registry, swapped in for the stock one through the
 * compiler's `additionalFiles` option (see Shop's paraglideVitePlugin block).
 *
 * The project's locale codes follow native's `language` launch param —
 * `zh_tw`, `zh_cn`, `pt_br` — and Intl only accepts BCP 47 tags, so the stock
 * registry throws "RangeError: Invalid language tag: zh_tw" on every plural
 * (or number / datetime) message in those locales. This copy hands Intl the
 * hyphenated tag; everything else is the stock registry verbatim.
 */

/**
 * @param {string} locale
 * @returns {string}
 */
function toIntlLocale(locale) {
  return locale.replace(/_/g, '-')
}

/**
 * @param {import("./runtime.js").Locale} locale
 * @param {unknown} input
 * @param {Intl.PluralRulesOptions} [options]
 * @returns {string}
 */
export function plural(locale, input, options) {
  return new Intl.PluralRules(toIntlLocale(locale), options).select(
    Number(input),
  )
}

/**
 * @param {import("./runtime.js").Locale} locale
 * @param {unknown} input
 * @param {Intl.NumberFormatOptions} [options]
 * @returns {string}
 */
export function number(locale, input, options) {
  return new Intl.NumberFormat(toIntlLocale(locale), options).format(
    Number(input),
  )
}

/**
 * @param {import("./runtime.js").Locale} locale
 * @param {unknown} input
 * @param {Intl.DateTimeFormatOptions} [options]
 * @returns {string}
 */
export function datetime(locale, input, options) {
  return new Intl.DateTimeFormat(toIntlLocale(locale), options).format(
    new Date(/** @type {string} */ (input)),
  )
}
